{
    "Profile_Renewal_Action.autoInsurance": "FR: auto Insurance",
    "Profile_Renewal_Action.fluxCommautoInsurance": "FR: flux-commauto Insurance",
    "Profile_Renewal_Action.bundleInsurance": "FR: bundle Insurance",
    "Profile_Renewal_Action.condoInsurance": "FR: condo Insurance",
    "Profile_Renewal_Action.homeInsurance": "FR: home Insurance",
    "Profile_Renewal_Action.landlordInsurance": "FR: landlord Insurance",
    "Profile_Renewal_Action.motorcycleInsurance": "FR: motorcycle Insurance",
    "Profile_Renewal_Action.roomateInsurance": "FR: roomate Insurance",
    "Profile_Renewal_Action.tenantInsurance": "FR: tenant Insurance",
    "Profile_Renewal_Action.rvInsurance": "FR: rv Insurance",
    "Profile_Renewal_Action.pleasurecraftInsurance": "FR: pleasurecraft Insurance",
    "Profile_Renewal_Action.name": "FR: Name",
    "Profile_Renewal_Action.address": "FR: Address",
    "Profile_Renewal_Action.contact": "FR: Contact",
    "Profile_Renewal_Action.viewPriorPolicy": "FR: View Prior Policy"
}
